import React, { createContext, useState } from "react";

import { CartonView } from "../models/carton";
import { Error } from "../models/error";
import { Milestone } from "../models/milestone";
import { PurchaseOrder, ValueOf } from "../models/purchase.order";
import { OrderStatus } from "../util/enums";

interface PurchaseOrderProps {
  purchaseOrder?: PurchaseOrder;
  setPurchaseOrder: (value: PurchaseOrder) => void;
  cartons: CartonView[];
  setCartons: React.Dispatch<React.SetStateAction<CartonView[]>>;
  handleUpdatePurchaseOrder: (
    attribute: keyof PurchaseOrder,
    value: ValueOf<PurchaseOrder> | null
  ) => void;
  responseError?: Error;
  setResponseError: (error: Error) => void;

  milestoneDates: Milestone[];
  setMilestoneDates: React.Dispatch<React.SetStateAction<Milestone[]>>;
}

const PurchaseOrderContext = createContext<PurchaseOrderProps>({} as PurchaseOrderProps);

interface PurchaseOrderProviderProps {
  children: React.ReactChild;
}

const PurchaseOrderProvider = ({ children }: PurchaseOrderProviderProps) => {
  const [purchaseOrder, setPurchaseOrder] = useState<PurchaseOrder>({
    status: OrderStatus.RECEIVED,
  } as PurchaseOrder);
  const [cartons, setCartons] = useState<CartonView[]>([]);
  const [responseError, setResponseError] = useState<Error>();

  const [milestoneDates, setMilestoneDates] = useState<Milestone[]>([]);

  const handleUpdatePurchaseOrder = (attribute: string, value: any) => {
    if (attribute && attribute !== "all") {
      if (!["string", "number", "boolean", "object"].includes(typeof value)) {
        setPurchaseOrder((state: any) => ({
          ...state,
          [attribute]: value ? [...value] : value,
        }));
      } else setPurchaseOrder((state: any) => ({ ...state, [attribute]: value }));
    } else {
      setPurchaseOrder({ ...value });
    }
  };

  return (
    <PurchaseOrderContext.Provider
      value={{
        purchaseOrder,
        setPurchaseOrder,
        cartons,
        setCartons,
        handleUpdatePurchaseOrder,
        responseError,
        setResponseError,
        milestoneDates,
        setMilestoneDates,
      }}
    >
      {children}
    </PurchaseOrderContext.Provider>
  );
};

export { PurchaseOrderContext, PurchaseOrderProvider };
